import { fetchHelper } from '../../../api/api'
import { fetchCourseDetails } from '../../../api/apiFunctions'
import { beneficiaryDetailsActions } from './userDetailsSlice'

export const getBeneficiaryDetails = email => async dispatch => {
    dispatch(beneficiaryDetailsActions.getBeneficiaryDetailsRequest())
    try {
        let [beneficiary, lastLogin, courses] = await Promise.all([
            fetchHelper(`Customer/${email}`).then(res => res.data),
            fetchHelper(`Loginentry/LastLogin/${email}`)
                .then(res => res.data.logindata)
                .catch(err => {
                    if (err.response?.status === 404) {
                        return Promise.resolve(null)
                    } else {
                        return Promise.reject('Something went wrong')
                    }
                }),
            fetchHelper(`Beneficiary/GetBeneficiaryCourses/${email}`).then(
                res => res.data
            ),
        ])

        const coursesDetails = await Promise.all(
            courses.map(({ coursecode }) => fetchCourseDetails(coursecode))
        )

        courses = courses.map((course, idx) => ({
            ...course,
            ...coursesDetails[idx],
        }))

        console.log(beneficiary)

        dispatch(
            beneficiaryDetailsActions.getBeneficiaryDetailsRequestSuccess({
                beneficiary: {
                    ...beneficiary,
                    lastLogin,
                    name: `${beneficiary.firstname} ${beneficiary.lastname}`,
                },
                courses,
            })
        )
    } catch (e) {
        dispatch(
            beneficiaryDetailsActions.getBeneficiaryDetailsRequestError(
                e.message
            )
        )
    }
}
